import { Fragment } from 'react'
import {
  Box,
  Container,
  Divider,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'
import { useNavigate } from 'react-router-dom'
import Spinner from '../../containers/Spinner'
import ProductsDetailOrder from '../ProductsDetailOrder'
import {
  formatter,
  getOrderTotalAmount,
  getOrderDate,
  getMonth
} from '../../utils/auxFunc'
import { monthNames } from '../../assets/constants'

const OrderDetail = ({ order }) => {
  const navigate = useNavigate()

  const handleNavCart = () => {
    navigate('/cart')
  }

  const handleReturn = () => {
    navigate(-1)
  }

  const date = new Date(order?.orderDate)
  const day = getOrderDate(date)
  const month = monthNames[getMonth(date)]
  const amount = order && getOrderTotalAmount(order?.orderItems)
  const discount = order?.discount && (order?.discount * amount) / 100

  return order ? (
    <Fragment>
      <Container>
        <Box display="flex" alignItems="center" minHeight="56px">
          <Box>
            <Tooltip title="Volver">
              <IconButton
                size="large"
                aria-label="volver"
                aria-controls="volver-carrito"
                aria-haspopup="false"
                color="inherit"
                onClick={handleReturn}
              >
                <ArrowBackIosIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography
            variant="h5"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
          >
            Pedido pendiente
          </Typography>
          <Box>
            <Tooltip title="Carrito">
              <IconButton
                size="large"
                aria-label="carrito"
                aria-controls="logo-carrito"
                aria-haspopup="false"
                color="inherit"
                onClick={handleNavCart}
              >
                <ShoppingBagOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Container>
      <Divider />
      <Container
        sx={{
          minHeight: 'calc(100vh - 478px)'
        }}
      >
        <Box display="flex" justifyContent="space-between" mt={2} mb={1}>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem'
            }}
          >
            {`${day} de ${month}`}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem'
            }}
          >
            {`Nº ${order?.idOrder}`}
          </Typography>
        </Box>
        <Divider />
        {order?.address ? (
          <Fragment>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="start"
              mt={2}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: '1rem',
                  color: (theme) => theme.palette.light.main
                }}
              >
                Enviado a:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {order?.name}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="start"
              mt={2}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: '1rem',
                  color: (theme) => theme.palette.light.main
                }}
              >
                Dirección de envío:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {order?.address}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {`CP: ${order?.clientZipCode}`}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {order?.clientState}
              </Typography>
            </Box>
          </Fragment>
        ) : (
          <Fragment>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="start"
              mt={2}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: '1rem',
                  color: (theme) => theme.palette.light.main
                }}
              >
                Dirección de retiro:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                Retira por sucursal: Conesa 3664 - CABA
              </Typography>
            </Box>
          </Fragment>
        )}
        <Box display="flex" flexDirection="column" alignItems="start" mt={2}>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: '1rem',
              color: (theme) => theme.palette.light.main
            }}
          >
            Forma de pago:
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem'
            }}
          >
            {order?.paymentMethod.toLowerCase() === 'cuenta corriente 2'
              ? 'Contado'
              : order?.paymentMethod}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="start"
          mt={2}
          mb={3}
        >
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: '1rem',
              color: (theme) => theme.palette.light.main
            }}
          >
            Estado:
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: order?.isPaid ? '#4DBAA2' : '#E80025',
              fontSize: '1rem'
            }}
          >
            {order?.state}
          </Typography>
        </Box>
        <Box py={3} mb={4} sx={{ backgroundColor: '#F5F6F7' }}>
          <Container>
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                Subtotal:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {formatter().format(amount)}
              </Typography>
            </Box>
            {discount !== 0 && (
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem'
                  }}
                >
                  Descuento:
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem'
                  }}
                >
                  {discount !== 0 ? `-${formatter().format(discount)}` : '$ 0'}
                </Typography>
              </Box>
            )}
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem',
                  fontWeight: '600'
                }}
              >
                Total:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem',
                  fontWeight: '600'
                }}
              >
                {discount === 0
                  ? formatter().format(amount)
                  : formatter().format(amount - discount)}
              </Typography>
            </Box>
          </Container>
        </Box>
      </Container>

      <Container sx={{ marginBottom: '3rem' }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: '1rem',
            fontWeight: '600'
          }}
        >
          Detalle de la orden
        </Typography>
        {order?.orderItems.map((product) => (
          <ProductsDetailOrder key={product.idProduct} product={product} />
        ))}
      </Container>
    </Fragment>
  ) : (
    <Spinner />
  )
}

export default OrderDetail
